import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function AamPanna() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Aam Panna</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 20 }}>Tangy raw-mango cooler — perfect for hot days and often said to help beat the heat.</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/aam_panna.svg" alt="Aam panna — chilled green mango drink in a glass" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 20px 0",
          maxWidth: 1200,
          margin: "0 auto",
          flexWrap: "wrap"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>1 medium raw green mangoes (unripe)</li>
              <li>1 cups water (for boiling and diluting)</li>
              <li>½–¾ cup grated jaggery or sugar, to taste</li>

            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Wash the raw mangoes. Pressure-cook or boil them in water until the peel is soft and the flesh is tender.</li>
              <li>Cool slightly, then squeeze or scoop out the soft pulp; discard the skin and stone.</li>
              <li>Blend 3tbsp of the pulp with jaggery until smooth.</li>
              <li>Blend with chilled water to your preferred thickness — aam panna is usually pourable, not too thick.</li>
              <li>Taste and adjust sweet or salt. Serve over plenty of  crushed ice in tall glasses.</li>
              <li>Keep the rest of the pulp for later use.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Pick firm, sour raw mangoes — the tartness is what makes aam panna refreshing.</li>
              <li>Roast the cumin seeds lightly before crushing them for a smokier, more aromatic finish.</li>
              <li>A pinch of black salt (kala namak) rounds out the sweetness beautifully.</li>
              <li>Chill the pulp fully before diluting — it keeps the drink from turning watery on ice.</li>
              <li>Make a big batch of pulp and freeze it in an ice tray for an instant drink anytime.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Raw mango is rich in vitamin C, which supports immunity in hot weather.</li>
              <li>Helps replace electrolytes and fluids lost to sweating, guarding against heat exhaustion.</li>
              <li>Cumin and black salt aid digestion and can soothe an upset stomach.</li>
              <li>Naturally low in fat, making it a lighter alternative to sugary sodas.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default AamPanna;
